import {createAction,props} from '@ngrx/store';
import {ProductPagedResponse } from '../../_models/product.interface';

export const LOADING_PRODUCTS = '[PRODUCTS] Loading products items';
export const LIST_PRODUCTS = '[PRODUCTS] List products items';
export const ERROR_PRODUCTS = '[PRODUCTS] Products Loaded Error';
export const CANCEL_PRODUCTS_REQUEST = '[PRODUCTS] Cancel products request';

export const LoadingProductsAction = createAction(
  LOADING_PRODUCTS,
  props<{payload:any}>()
);
export const ListProductsAction = createAction(
  LIST_PRODUCTS,
  props<{data: ProductPagedResponse,provider:number,scroll:boolean}>()
);
export const ErrorProductsAction = createAction(LIST_PRODUCTS);
export const CancelProductRequestAction = createAction(CANCEL_PRODUCTS_REQUEST);
